<template>
  <BasePage :pageTitle="weekName" show-alt-menu show-footer :show-header="false">
    <div class="bg-primary hero-header">
      <div class="hero-row row p-4">
        <div class="col-3">
          <img :src="logoUrl" class="hero-logo" :class="{ 'hero-logo-invert': brandConfig.logoVariant === 'dark' }" alt=""/>
        </div>
        <div class="col p-1 ms-2">
          <span class="text-white h1">{{ weekName?.split(" | ")[0] || '' }}</span><br/>
          <span class="text-white"> {{ weekName?.split(" | ")[1] || '' }}</span>
        </div>
      </div>
    </div>
    <div class="container-xl py-3" style="margin-top: 0px">
      <!-- People Section -->
      <div class="menu-section-heading mb-2">{{ __DICT__.hub?.people || 'People' }}</div>
      <div class="row g-3 mb-2">
        <div v-for="(option, index) in peopleOptions" :key="'p-'+index" class="col-6 col-sm-4 col-lg-3">
          <div class="menu-card" @click="navigateTo(option.route)">
            <div class="icon-container">
              <component :is="option.icon" stroke="2.5"/>
            </div>
            <div class="title-container">
              <h3>{{ option.title }}</h3>
            </div>
          </div>
        </div>
      </div>

      <!-- Transport Section -->
      <div class="menu-section-heading mb-2">{{ __DICT__.hub?.transport || 'Transport' }}</div>
      <div class="row g-3 mb-2">
        <div v-for="(option, index) in transportOptions" :key="'t-'+index" class="col-6 col-sm-4 col-lg-3">
          <div class="menu-card" @click="navigateTo(option.route)">
            <div class="icon-container">
              <component :is="option.icon" stroke="2.5"/>
            </div>
            <div class="title-container">
              <h3>{{ option.title }}</h3>
            </div>
          </div>
        </div>
      </div>

      <!-- Activities Section -->
      <div class="menu-section-heading mb-2">{{ __DICT__.hub?.activities || 'Activities' }}</div>
      <div class="row g-3 mb-2">
        <div v-for="(option, index) in activitiesOptions" :key="'a-'+index" class="col-6 col-sm-4 col-lg-3">
          <div class="menu-card" @click="navigateTo(option.route)">
            <div class="icon-container">
              <component :is="option.icon" stroke="2.5"/>
            </div>
            <div class="title-container">
              <h3>{{ option.title }}</h3>
            </div>
          </div>
        </div>
      </div>

      <!-- Information Section -->
      <div class="menu-section-heading mb-2">{{ __DICT__.hub?.information || 'Information' }}</div>
      <div class="row g-3 mb-4">
        <div v-for="(option, index) in infoOptions" :key="'i-'+index" class="col-6 col-sm-4 col-lg-3">
          <div class="menu-card" @click="navigateTo(option.route)">
            <div class="icon-container">
              <component :is="option.icon" stroke="2.5"/>
            </div>
            <div class="title-container">
              <h3>{{ option.title }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BasePage>
</template>

<script setup>
import {useWeekStore} from "@/stores/week.js";
import {
  IconUserSearch,
  IconUserShield,
  IconBuildingSkyscraper,
  IconBus,
  IconCar,
  IconSchool,
  IconSnowboarding,
  IconCalendarEvent,
  IconClipboardList,
  IconMoonStars,
} from '@tabler/icons-vue';
import BasePage from "@/components/BasePage.vue";
import {useRouter} from "vue-router";
import squareLogo from '@brand/assets/square.png'
import brandConfig from '@brand/config.js'

const logoUrl = squareLogo
const router = useRouter();
const weekStore = useWeekStore();
const navigateTo = (route) => {
  router.push({name: route});
};

const peopleOptions = [
  {title: __DICT__.menuOptions.SearchPassengers, icon: IconUserSearch, route: 'SearchPassengers'},
  {title: __DICT__.menuOptions.SearchStaff, icon: IconUserShield, route: 'SearchStaff'},
]

const transportOptions = [
  {title: __DICT__.menuOptions.Coaches, icon: IconBus, route: 'Coaches'},
  {title: __DICT__.menuOptions.Transfers, icon: IconCar, route: 'Transfers'},
]

const activitiesOptions = [
  {title: __DICT__.menuOptions.Lessons, icon: IconSchool, route: 'Lessons'},
  {title: __DICT__.menuOptions.Workshops, icon: IconSnowboarding, route: 'Workshops'},
  {title: __DICT__.menuOptions.Events, icon: IconCalendarEvent, route: 'Events'},
  {title: __DICT__.menuOptions.NightlifePlan, icon: IconMoonStars, route: 'NightlifePlan'},
]

const infoOptions = [
  {title: __DICT__.menuOptions.Accommodation, icon: IconBuildingSkyscraper, route: 'Accommodation'},
  {title: __DICT__.menuOptions.WeeklyInfo, icon: IconClipboardList, route: 'WeeklyInfo'},
]

const weekName = weekStore.weekName;
</script>

<!-- Menu card styles from shared _menu-cards.scss -->
